import { MessageCircle, Phone, Mail, Globe, MapPin } from 'lucide-react';
import { BRAND, AREAS } from '../config/site';
import BrandLogo from './BrandLogo';

export const Footer = () => (
  <footer className="ks-footer relative text-white">
    <div className="mx-auto max-w-7xl border-t border-white/10 px-4 pb-28 pt-14 sm:px-6 md:pb-16 lg:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <BrandLogo footer />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/70">
            Premium residential cleaning for homes, apartments and townhomes across Central Florida
            and surrounding areas.
          </p>
        </div>

        <div data-testid="footer-contact">
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-aqua">Contact</h3>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a href={BRAND.phoneHref} data-testid="footer-call-link" className="inline-flex items-center gap-3 font-semibold transition-colors hover:text-aqua">
                <Phone size={15} className="shrink-0" aria-hidden="true" />
                Call Us: {BRAND.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={BRAND.smsHref} data-testid="footer-text-link" className="inline-flex items-center gap-3 font-semibold transition-colors hover:text-aqua">
                <MessageCircle size={15} className="shrink-0" aria-hidden="true" />
                Text Us: {BRAND.smsDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="inline-flex items-center gap-3 break-all transition-colors hover:text-aqua">
                <Mail size={15} className="shrink-0" aria-hidden="true" />
                {BRAND.email}
              </a>
            </li>
            <li>
              <span className="inline-flex items-center gap-3 text-white/80">
                <Globe size={15} className="shrink-0" aria-hidden="true" />
                {BRAND.website}
              </span>
            </li>
          </ul>
        </div>

        <div data-testid="footer-areas">
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-aqua">Service Areas</h3>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm text-white/80">
            {AREAS.map((a) => (
              <li key={a} className="inline-flex items-center gap-2">
                <MapPin size={12} className="shrink-0 text-aqua/70" aria-hidden="true" />
                {a}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-white/60">
        <p>© 2026 KINDSTONE Cleaning Services. All rights reserved.</p>
        <a href="/privacy.html" className="mt-2 inline-block underline underline-offset-4 transition-colors hover:text-aqua">Privacy Policy</a>
        <span aria-hidden="true" className="mx-2">·</span>
        <button
          type="button"
          onClick={() => window.dispatchEvent(new Event("kindstone:meta-consent-settings"))}
          className="mt-2 underline underline-offset-4 transition-colors hover:text-aqua"
        >
          Privacy &amp; tracking choices
        </button>
      </div>
    </div>
  </footer>
);

export default Footer;
